import api from './api'

const notificationsDataProvider = {
  showMessages() {
    return api.get('Notification/api/Notification/GetDefaultMessages')
  },
  selectMessage(params) {
    return api.post('Notification/api/Notification/SendSelectedMessage', params)
  },
  addMessage(params) {
    return api.post('Notification/api/Notification/SendNewMessage', params)
  },
  addNewInvitaion(params) {
    return api.post('Invitation/api/Invite/Register', params)
  },
  sendNotif(params) {
    return api.post('Invitation/api/Invite/SendNotificaton', params)
  },
  getFollowUp() {
    return api.get('Invitation/api/Invite/Reminder')
  },
  fireNotif(params) {
    return api.post('Invitation/api/Invite/FireNotification', params)
  },
  setBlackList(params) {
    return api.post('Invitation/api/Invite/BlackList', params)
  },
  
}

export default notificationsDataProvider
